import React from 'react'
import { BsFacebook, BsInstagram, BsYoutube } from 'react-icons/bs';

const FacebookIcon = () => {
    return (
       <BsFacebook className="text-2xl"/>
    )
};

const InstagranIcon = () => {
    return (
        <BsInstagram className="text-2xl"/>
    )
}

const YoutubeIcon = () => {
    return (
        <BsYoutube className="text-2xl"/>
    )
}

export { FacebookIcon, InstagranIcon, YoutubeIcon };

